export const initialNodes = [
    {
        id: "node-1",
        type: "simpletrait",
        data: {
            title: "Metalness",
            label: "Number",
            value: "1",
            type: "float"
        },
        position: {x: 10, y: 0}
    },
    {
        id: "node-2",
        type: "simpletrait",
        data: {
            title: "Roughness",
            label: "Number",
            value: "0.567",
            type: "float"
        },
        position: {x:270, y:10}
    },
    {
        id: "node-3",
        type:"singlvectortrait",
        data: {
            title: "color",
            type: "VECTOR3",
            x: "0.5",
            y: "0.5",
            z: "0.5"
        },
        position: {x: 530, y: 50}
    },
    {
        id: "node-4",
        type: "multitrait",
        data: {
            title: "Hell",
            label: "FRAG",
            sectionTitle: "Uniforms",
        },
        height: '600px',
        position: {x: 300, y: 0}
    },
    {
        id: "node-5",
        type: "singletrait",
        hidden: false,
        data: {
          name: "modelMatrix",
          type: "mat4",
          outputType: "vector4"
        },
        position: { x: 0, y: 100 },
        parentId: "node-4",
        extent: "parent",
        draggable: false,
      },
      {
        id: "node-6",
        type: "singletrait",
        hidden: false,
        data: {
          name: "color",
          type: "vector3",
          outputType: "vector4"
        },
        position: { x: 0, y: 140 },
        parentId: "node-4",
        extent: "parent",
        width: 300,
        draggable: false,
      }
]

export let childrenData = [
    {
      id: "node-5",
      type: "singletrait",
      hidden: false,
      data: {
        name: "modelMatrix",
        type: "mat4",
        outputType: "vector4"
      },
      position: { x: 0, y: 60 },
      parentId: "node-4",
      extent: "parent",
      draggable: false,
    },
    {
      id: "node-6",
      type: "singletrait",
      hidden: false,
      data: {
        name: "color",
        type: "vector3",
        outputType: "vector4"
      },
      position: { x: 0, y: 0 },
      parentId: "node-4",
      extent: "parent",
      width: 300,
      draggable: false,
    }
  ];

export const initialEdges = [
    {
        id: "edge1",
        source: "node-1",
        target: "node-2",
        type: "smoothstep",
        data: { label: "Edge 1" },
    }
]